<div *ngIf="loading ==true"
  style="display: flex;flex-direction: column;align-items: center;justify-content: center;min-height: 600px;align-self: center;">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="loading !=true && DataForFormSetup" style="display: flex;flex-direction: column;min-height: 600px;padding-left: 10px;
padding-right: 10px;">

  <div style="display: flex;align-self: center;margin-top: 20px;">
    <h1>{{'Setup Forms' | translate | async}}</h1>
  </div>

  <table class="table table--full-width table--striped" style="margin-top: 9px;"
    *ngFor="let cat of DataForFormSetup?.Categories">
    <thead>
      <tr>
        <th style="display: flex;
        flex-direction: column;
        margin-bottom: 20px;margin-top: 20px;background: white;">
          <div style="display: flex;flex-direction: row;align-items: center;">
            <span style="font-weight: bold;font-size: 30px;">
              {{cat.Name}}
            </span>
            <i (click)="ClickEditCatName(cat)" class="material-icons button__icon"
              style="cursor: pointer;margin-left: 20px;">edit</i>

            <mat-checkbox [(ngModel)]="cat.RequireIncidentNo" style="margin-left: 20px;"
              (change)="changeCheckboxIncidentReport(cat,cat.RequireIncidentNo)">{{"Report / Incident # required" | translate | async}}
            </mat-checkbox>

          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let form of cat.Forms">

        <td>
          <div style="display: flex;flex-direction: row;flex:1;">
            <i (click)="CkickDeleteForm(form)" class="material-icons button__icon"
              style="color:green;cursor: pointer;margin-right: 20px;">done</i>
            <div style="flex:1"><span>
                {{form.Name}}
              </span></div>

            <div style="flex:0.1;display: flex;justify-content: center;align-items: center;">
              <div style="display: flex;justify-content: center;align-items: center;"><i
                  (click)="ClickEditFormName(form)" class="material-icons button__icon"
                  style="cursor: pointer;">edit</i></div>

            </div>

            <div style="flex:0.5">
              <div *ngIf="form.IsDigital"><span>{{'Digital Form' | translate | async}}</span></div>
              <div *ngIf="form.IsDigital != true" style="display: flex;
              align-items: center;"><i (click)="ClickEditFormName(form)" class="material-icons button__icon"
                  style="cursor: pointer;">picture_as_pdf</i><span style="display:inline-block;
                  width:180px;
                  white-space: nowrap;
                  overflow: hidden;margin-left: 20px;
                  text-overflow: ellipsis;">{{form.Filename}}</span></div>

            </div>
          </div>
        </td>
      </tr>
      <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
        <button class="button button--primary" style="margin-left: 20px;" (click)="onClickAddForm(cat)">
          <span class="button__text">+ {{'Add Form'| translate | async}}</span>
        </button>
      </div>
    </tbody>
  </table>

  <div style="justify-content: flex-end;margin-bottom: 10px;">
    <button class="button button--primary" style="margin-left: 20px;" (click)="ClickAddCatName()">
      <span class="button__text">+ {{'Add Form Category' | translate | async}}</span>
    </button>
  </div>
  <!-- <mat-list role="list" *ngFor="let cat of DataForFormSetup?.Categories">
    <mat-list-item role="listitem" style="display: flex;
    flex-direction: column;
    margin-bottom: 20px;margin-top: 20px;">

      <div style="display: flex;flex-direction: row;align-items: center;">
        <span style="font-weight: bold;font-size: 30px;">
          {{cat.Name}}
        </span>
        <i (click)="ClickEditCatName(cat)" class="material-icons button__icon"
          style="cursor: pointer;margin-left: 20px;">edit</i>

        <mat-checkbox [(ngModel)]="cat.RequireIncidentNo" style="margin-left: 20px;"
          (change)="changeCheckboxIncidentReport(cat,cat.RequireIncidentNo)">Report / Incident # required</mat-checkbox>

      </div>

    </mat-list-item>

    <mat-list role="list" *ngFor="let form of cat.Forms">
      <mat-list-item class="no-wrap" role="listitem" style="display: flex;
      flex-direction: column">

        <div style="display: flex;flex-direction: row;flex:1">
          <i (click)="CkickDeleteForm(form)" class="material-icons button__icon"
            style="color:green;cursor: pointer;margin-right: 20px;">done</i>
          <div style="flex:1"><span>
              {{form.Name}}
            </span></div>

          <div style="flex:0.1;display: flex;justify-content: center;align-items: center;">
            <div style="display: flex;justify-content: center;align-items: center;"><i (click)="ClickEditFormName(form)"
                class="material-icons button__icon" style="cursor: pointer;">edit</i></div>

          </div>

          <div style="flex:0.5">
            <div *ngIf="form.IsDigital"><span>Digital Form</span></div>
            <div *ngIf="form.IsDigital != true" style="display: flex;
            align-items: center;"><i (click)="ClickEditFormName(form)" class="material-icons button__icon"
                style="cursor: pointer;">picture_as_pdf</i><span style="display:inline-block;
                width:180px;
                white-space: nowrap;
                overflow: hidden;margin-left: 20px;
                text-overflow: ellipsis;">{{form.Filename}}</span></div>

          </div>
        </div>


      </mat-list-item>

    </mat-list>

    <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
      <button class="button button--primary" style="margin-left: 20px;" (click)="onClickAddForm(cat)">
        <span class="button__text">+ Add Form</span>
      </button>
    </div>


    <mat-divider></mat-divider>
  </mat-list> -->

</div>